import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { actions } from '../constants/cms_lightbox/actions';

class CmsLightboxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            headline: '',
            subHeadline: '',
            footerText: '',
            footerCloseText: '',
        };
    }

    reduce( state, { source, action } ) {
        const { type, payload } = action;

        if (source === ACTION_TYPES.CMS_LIGHTBOX_ACTION) {
            switch ( type ) {
                case actions.SHOW:
                    if ( !state.visible ) {
                        state.visible = true;
                        this.__emitChange();
                    }
                    break;

                case actions.HIDE:
                    if ( state.visible ) {
                        state.visible = false;
                        this.__emitChange();
                    }
                    break;

                case actions.SET_HEADLINE:
                    if (state.headline !== payload) {
                        state.headline = payload;
                        this.__emitChange();
                    }
                    break;

                case actions.SET_SUB_HEADLINE:
                    if (state.subHeadline !== payload) {
                        state.subHeadline = payload;
                        this.__emitChange();
                    }
                    break;

                case actions.SET_FOOTER_TEXT:
                    if (state.footerText !== payload) {
                        state.footerText = payload;
                        this.__emitChange();
                    }
                    break;

                case actions.SET_FOOTER_CLOSE_TEXT:
                    if (state.footerCloseText !== payload) {
                        state.footerCloseText = payload;
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}

const CmsLightboxStore = new CmsLightboxStoreClass( Dispatcher );
export default CmsLightboxStore;
